import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../utils/msalConfig';

export default function LoginPage() {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      await instance.loginRedirect(loginRequest);
    } catch (e) {
      console.error('Login failed:', e);
      setError('Login failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--color-bg)' }}>
      <div style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)',
        borderRadius: 12, padding: '48px 40px', width: 360, textAlign: 'center' }}>
        <div style={{ marginBottom: 32 }}>
          <div style={{ fontSize: '1.4rem', fontWeight: 600, color: 'var(--color-text)',
            letterSpacing: '-0.02em' }}>
            Vela Companies
          </div>
          <div style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)', marginTop: 4 }}>
            Relationship Hub
          </div>
        </div>

        <div style={{ width: 48, height: 48, borderRadius: 10, background: 'var(--color-success)',
          margin: '0 auto 24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="9" cy="7" r="4" stroke="white" strokeWidth="2"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>

        <h1 style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: 8,
          color: 'var(--color-text)' }}>
          Sign in to continue
        </h1>
        <p style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)',
          marginBottom: 28, lineHeight: 1.5 }}>
          Use your Vela Companies Microsoft 365 account
        </p>

        {error && (
          <div style={{ background: 'rgba(196,92,92,0.1)', border: '1px solid rgba(196,92,92,0.3)',
            borderRadius: 6, padding: '8px 12px', fontSize: '0.82rem',
            color: 'var(--color-danger)', marginBottom: 16 }}>
            {error}
          </div>
        )}

        <button onClick={handleLogin} disabled={loading} style={{ width: '100%',
          padding: '10px 16px', borderRadius: 8, border: '1px solid var(--color-border)',
          background: loading ? 'var(--color-border)' : 'var(--color-surface)',
          color: 'var(--color-text)', fontSize: '0.9rem', fontWeight: 500,
          cursor: loading ? 'not-allowed' : 'pointer', display: 'flex',
          alignItems: 'center', justifyContent: 'center', gap: 10,
          fontFamily: 'var(--font-ui)' }}>
          {!loading && (
            <svg width="18" height="18" viewBox="0 0 21 21" fill="none">
              <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
              <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
              <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
            </svg>
          )}
          {loading ? 'Redirecting to Microsoft...' : 'Sign in with Microsoft'}
        </button>

        <p style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', marginTop: 20 }}>
          Access is managed by your administrator
        </p>
      </div>
    </div>
  );
}